import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { SlingoEvent } from "../../../controller/event/SlingoEvent";
import { SlingoLang } from "../lang/SlingoLang";
import { AbstractPayTable } from "./AbstractPayTable";
/**
 * PayTable.ts
 */
export class PayTable extends AbstractPayTable {
    create() {
        this.createScatter();
        this.createBackground();
        this.createFrame();
        super.create();
    }
    createScatter() {
        if (this.landscapeProperties.scatterProperties) {
            this.scatterBackground = TitanSprite.createSprite(this, "scatterBackground", this.landscapeProperties.scatterProperties.backgroundProperties, this.portraitProperties?.scatterProperties.backgroundProperties);
            this.scatterTitle = ViewUtils.createField(this, this.landscapeProperties.scatterProperties.titleFieldProperties, this.portraitProperties?.scatterProperties.titleFieldProperties);
            this.scatterValue = ViewUtils.createField(this, this.landscapeProperties.scatterProperties.valueFieldProperties, this.portraitProperties?.scatterProperties.valueFieldProperties);
        }
    }
    createBackground() {
        if (this.landscapeProperties.backgroundProperties) {
            this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
        }
    }
    createFrame() {
        if (this.landscapeProperties.frameProperties) {
            this.frame = TitanSprite.createSprite(this, "frame", this.landscapeProperties.frameProperties, this.portraitProperties?.frameProperties);
        }
    }
    createCells() {
        this.cells = [];
        for (let i = 0; i < 11; i++) {
            this.createCell(i);
        }
        //Reparent cell backgrounds to this container so the can all be positioned correctly
        //Place in front of background if there is one
        const bgIndex = (this.background && this.background.parent === this) ? this.getChildIndex(this.background) + 1 : 0;
        this.cells.forEach(cell => {
            const bg = cell.getBackground();
            const fx = cell.getEffects();
            if (fx) {
                this.addChildAt(fx, bgIndex);
            }
            if (bg) {
                this.addChildAt(bg, bgIndex);
            }
        });
        this.cellPanel.arrange();
    }
    createCell(childIndex) {
        const cell = this.factory.createPayTableCell(this.uiProperties.cellProperties[childIndex]);
        const prefix = this.uiProperties.cellProperties[childIndex].useShortLabel ? SlingoLang.SLINGO_SHORT : SlingoLang.SLINGO;
        const id = this.uiProperties.cellProperties[childIndex].id;
        cell.setLabel(prefix + (id === "11" ? "12" : id));
        this.cellPanel.addToPanel(cell, false);
        this.cells.push(cell);
    }
    updatePrizeValues() {
        const payoutConfig = this.model.getPayoutConfig();
        const currentStake = this.model.getCurrentStake();
        const payouts = payoutConfig.getPatternPayouts();
        payouts.reverse();
        payouts.splice(1, 1);
        let value;
        for (let i = 0; i < this.cells.length; i++) {
            value = currentStake * payouts[i];
            this.cells[i].update(value);
        }
        //scatter value
        if (this.scatterValue) {
            let symbolPayouts = payoutConfig.getSymbolPayouts();
            let symbolMultipliers = symbolPayouts.getValue(undefined).getMultipliers();
            value = currentStake * symbolMultipliers[5];
            let scatterValue = this.formatCurrency(value);
            this.scatterValue.setText(scatterValue);
        }
        this.dispatchGame(SlingoEvent.PAY_TABLE_UPDATE);
    }
}
//# sourceMappingURL=PayTable.js.map